module.exports = __webpack_public_path__ + "273912880c26b09b4a9c50f67e36b9c0.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/url-loader??ref--8-1!./node_modules/image-webpack-loader??ref--8-2!./node_modules/srcset-loader/lib/resize-loader.js?size=1200!./src/components/cover/teaser-dark.png?size=1200w
// module id = 40
// module chunks = 1